export default "M61 28H36V3c0-1.65-1.35-3-3-3h-2c-1.65 0-3 1.35-3 3v25H3c-1.65 0-3 1.35-3 3v2c0 1.65 1.35 3 3 3h25v25c0 1.65 1.35 3 3 3h2c1.65 0 3-1.35 3-3V36h25c1.65 0 3-1.35 3-3v-2c0-1.65-1.35-3-3-3";
